// Status de item de proposta e de proposta usados no fluxo de desconto por item.
// Ids fixos em todos os ambientes (confirmado com o backend em 2026-07-06).

export const ITEM_PROPOSTA_STATUS = {
  AGUARDANDO_COMPRAS: 3,
  REGULARIZADO: 4,
  AGUARDANDO_DESCONTO_COMPRAS: 7,
  RECUSADO_COMPRAS: 8,
} as const

export const PROPOSTA_STATUS = {
  ANALISE_CLIENTE: 4,
  AGUARDANDO_DESCONTO_COMPRAS: 10,
} as const
